import { useContext, useRef, useState, useEffect } from "react";
import { Context } from "../../Context/Context";
import { authApi } from "../../services";
import "./Login.css";

export default function Login() {
  const userRef = useRef();
  const passwordRef = useRef();
  const [error, setError] = useState(false);
  const { dispatch, isFetching } = useContext(Context);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });
    try {
      const credentials = {
        username: userRef.current.value,
        password: passwordRef.current.value,
      };
      const userData = await authApi.login(credentials);
      if (isMounted.current) {
        dispatch({ type: "LOGIN_SUCCESS", payload: userData });
        setError(false);
      }
    } catch (err) {
      if (isMounted.current) {
        dispatch({ type: "LOGIN_FAILURE" });
        setError(true);
      }
    }
  };

  return (
    <div className="login">
      {/* Animated background orbs */}
      <div className="login-orb login-orb--1"></div>
      <div className="login-orb login-orb--2"></div>
      <div className="login-orb login-orb--3"></div>

      <div className="login-card">
        {/* Branding */}
        <div className="login-brand">
          <div className="login-logo">
            <span className="login-logo-icon">CF</span>
          </div>
          <h1 className="login-brand-title">HoangLeCF</h1>
          <p className="login-brand-subtitle">Admin Control Panel</p>
        </div>

        {/* Form */}
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <div className="login-field-icon">
              <i className="fas fa-user"></i>
            </div>
            <input
              type="text"
              className="login-input"
              placeholder="Tên đăng nhập"
              ref={userRef}
              autoComplete="username"
            />
          </div>

          <div className="login-field">
            <div className="login-field-icon">
              <i className="fas fa-lock"></i>
            </div>
            <input
              type="password"
              className="login-input"
              placeholder="Mật khẩu"
              ref={passwordRef}
              autoComplete="current-password"
            />
          </div>

          <button
            className="login-button"
            type="submit"
            disabled={isFetching}
          >
            {isFetching ? (
              <span className="login-button-loader"></span>
            ) : (
              <>
                <span>Đăng nhập</span>
                <i className="fas fa-arrow-right"></i>
              </>
            )}
          </button>

          {error && (
            <div className="login-error">
              <i className="fas fa-exclamation-circle"></i>
              <span>Sai tên đăng nhập hoặc mật khẩu!</span>
            </div>
          )}
        </form>

        <div className="login-footer">
          <span>© 2024 HoangLeCF — All rights reserved</span>
        </div>
      </div>
    </div>
  );
}
